// @flow
import React from 'react';
import styled, { keyframes } from 'styled-components';
import Trash from 'AssetsRoot/images/homie_v3/trash.svg.react';
import * as Layout from 'styles/Layout';
import Asset from 'models/homes/Asset';
import { media } from 'styles/Mixins';
import { Common } from 'utils/ExportCommon';

const FileLoadedContainer = styled(Layout.FlexColumn)`
  width: 110px;
  position: relative;
  flex-wrap: wrap;
  margin: 4px 8px;
  opacity: ${props => (props.isDeleting ? '0.5' : '1')};
  ${media.sm`
    width: 120px;
    margin: 6px 10px;
  `}
`;

const FileLoadedPreview = styled.img.attrs({
  src: ({ src }) => src
})`
  height: 110px;
  width: 110px;
  margin-bottom: 4px;
  object-fit: cover;
  ${media.sm`
  height: 120px;
    width: 120px;
  `}
`;

const FileLoadingContainer = styled(Layout.FlexColumn)`
  justify-content: center;
  align-items: center;
  height: 110px;
  width: 110px;
  ${media.sm`
  height: 120px;
    width: 120px;
  `}
  margin-bottom: 4px;
`;

const FileLoadingText = styled.span`
  display: block;
  min-height: 16px;
  color: #9b9b9b;
  font-size: 13px;
  line-height: 16px;
  margin-top: 4px;
`;

const FileLoadedName = styled.span`
  min-height: 15px;
  width: 100%;
  color: #7c7c7c;
  font-size: 12px;
  line-height: 15px;
  word-break: break-all;
`;

const loadingAnim = keyframes`
 0 {transform: rotate(0deg);}
  50% {transform: rotate(180deg);}
  100% {transform: rotate(360deg);}
`;

const LoadingView = styled.div`
  width: 10px;
  height: 10px;
  margin: 0 auto;
  padding: 10px;
  border: 6px dashed ${props => props.color};
  border-radius: 100%;
  animation: ${loadingAnim} 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67)
    infinite;
`;

const DeleteFileButton = styled.div`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  height: 40px;
  width: 40px;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: background-color 0.2s linear;
  z-index: 2;
  &:hover {
    background-color: #ff1a00;
  }
`;

const TrashIcon = styled(Trash)`
  position: absolute;
  height: 22px;
  width: 20px;
  top: 9px;
  left: 10px;
`;

type PropsType = {
  asset: Asset,
  uploadFileAction: (file: File, idTempAsset: string) => void,
  onDeleteFileLoaded: (id: string) => void,
  loadingColor?: string,
  showDeleteButton?: boolean
};

type StateType = {
  deleting: boolean
};

export default class FileLoadComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    loadingColor: '#bdb4fd',
    showDeleteButton: true
  };

  state = {
    deleting: false
  };

  componentDidMount() {
    if (this.props.asset.file !== null) {
      this.props.uploadFileAction(this.props.asset.file, this.props.asset.id);
    }
  }

  componentDidUpdate(prevProps: PropsType) {
    if (this.props.asset.id !== prevProps.asset.id) {
      this.setState({ deleting: false });
    }
  }

  deleteFileLoaded = (assetId: string) => {
    this.setState(() => {
      return { deleting: true };
    }, this.props.onDeleteFileLoaded(assetId));
  };

  renderDeleteButton = () => {
    if (!this.props.showDeleteButton) return null;
    const { deleting } = this.state;
    return (
      <DeleteFileButton
        isVisible={!deleting}
        onClick={() => this.deleteFileLoaded(this.props.asset.id)}
      >
        <TrashIcon />
      </DeleteFileButton>
    );
  };

  render() {
    const { asset, loadingColor } = this.props;
    const { deleting } = this.state;

    return (
      <FileLoadedContainer isDeleting={deleting}>
        <Layout.FlexColumn isVisible={!asset.file}>
          <FileLoadedPreview
            src={
              asset.image_url &&
              asset.image_url.toLocaleLowerCase().search('.pdf') > -1
                ? Common.PDFIcon
                : asset.image_url
            }
          />
          <FileLoadedName>{asset.image_file_name}</FileLoadedName>
          {this.renderDeleteButton()}
        </Layout.FlexColumn>
        <Layout.FlexColumn isVisible={!asset.keepInLocal && asset.file}>
          <FileLoadingContainer>
            <LoadingView color={loadingColor} />
            <FileLoadingText>Subiendo</FileLoadingText>
          </FileLoadingContainer>
        </Layout.FlexColumn>
      </FileLoadedContainer>
    );
  }
}
